import { RecoilI18nDialog } from '@zurich/ui/legacy/components';
import AlertDialogs from './AlertDialogs';

export function Dialogs() {
  return (
    <>
      <AlertDialogs />
      <RecoilI18nDialog />
    </>
  );
}
